// extracted by mini-css-extract-plugin
export default {"videoContainer":"NXjNumnp293i9GUzV8wF","desktopVideo":"UTZQYezxYIdjdCHfJa1F","mobileVideo":"gGeHZamNnF43QZQ0haAH"};